import script from "./PriceTooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./PriceTooltip.vue?vue&type=script&setup=true&lang=js"

import "./PriceTooltip.vue?vue&type=style&index=0&id=290d85b7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-290d85b7"]])

export default __exports__